export const isImageSource = (value: string) => {
  const source = value.trim();
  return (
    /^(https?:)?\/\//i.test(source) ||
    /^data:image\//i.test(source) ||
    /^blob:/i.test(source)
  );
};
